import { crmPostCall } from '../../axios';
import { helpCenterApi } from '../../../utils/functions/helpCenterApis';
import { GETRESOLUTIONDATEURLJM, SERVERERROR } from '../constants';

export const getResolutionDateUrl = helpCenterApi(GETRESOLUTIONDATEURLJM);
const getResolutionDateRequest = (state, body) => {
  const url = getResolutionDateUrl;
  if (url) {
    return crmPostCall(state, url, body);
  }
  return Promise.reject(new Error(SERVERERROR));
};

export default { getResolutionDateRequest };
